module.exports = __webpack_public_path__ + "img/number_01.ae715f1d.svg";